import { Component } from '@angular/core';
import { ToastService, ToastInfo } from 'src/app/services/toast/toast.service';

@Component({
  selector: 'app-toast-container',
  templateUrl: './toast-container.component.html',
  styleUrls: ['./toast-container.component.css']
})
export class ToastContainerComponent {

  constructor(public toastService: ToastService) {}

  onClose(toastId: string): void {
    this.toastService.remove(toastId);
  }

  onActionClick(action: any, toastId: string): void {
    this.toastService.executeAction(action, toastId);
  }

  trackByToastId(index: number, toast: ToastInfo): string {
    return toast.id;
  }
}
